import { axiosPrivate } from "../api/axios";
import { COUNTRIES_API, PROGRAMTYPES_API } from "./endpoints";

export const countriesAPI = () => {
  return axiosPrivate.get(COUNTRIES_API);
};

export const programTypesAPI = () => {
  return axiosPrivate.get(PROGRAMTYPES_API);
};
